exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".OTPublisherContainer,\n.OTSubscriberContainer {\n  width: 100% !important;\n  height: 100% !important;\n}\n\nh1.OT_name.OT_edge-bar-item.OT_mode-auto {\n  display: none !important;\n}\n\n.opentok-join-meeting {\n  background: url(" + require("../../assets/agora-room.png") + ") no-repeat;\n  background-size: cover;\n}\n\n.opentok-join-meeting-audience {\n  background: url(" + require("../../assets/agora-audience.png") + ") no-repeat;\n  background-size: cover;\n  border: black 2px solid;\n}\n\n.full-screen-player, .full-screen-player div, .full-screen-player video {\n  background-color: initial !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/app/components/sdks/vonage/assets/css/style.css
// module id = 1399
// module chunks = 0